<template>
  <div v-if="totolView > 1 || pageNumber.length > 1" class="page-navigation">
    <template v-if="!isMobile">
      <button
        :disabled="!prev"
        class="prev"
        title="이전"
        @click.prevent="prevPage"
      >
        <icon-chevron-left />
      </button>

      <button
        v-for="number in pageNumber"
        :key="number"
        :class="{active : number === current}"
        @click.prevent="goPage(number)"
      >
        {{ number }}
      </button>

      <button
        :disabled="!next"
        class="next"
        title="다음"
        @click.prevent="nextPage"
      >
        <icon-chevron-right />
      </button>
    </template>
    <template v-else>
      <template v-if="!(total <= minimumSize) && !moreActivation">
        <button
          type="button"
          class="btn btn-more"
          @click.prevent="more"
        >
          {{ $t('detail.seeMore') }}
        </button>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  components: {
    iconChevronLeft: () => import('@/static/svg/chevron-left.svg'),
    iconChevronRight: () => import('@/static/svg/chevron-right.svg'),
  },
  props: {
    data: {
      type: Object,
      default: function () {
        return {
          current: 0,
          total: 0,
          length: 0,
        }
      }
    },
    moreActivation: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
    },
    pageQuery: {
      type: String,
      default: 'page'
    },
    minimumSize: {
      type: Number,
      default: 20
    }
  },
  data () {
    return {
      block: 5,
      viewPage: 1,
    }
  },
  computed: {
    prev: function () {
      return this.viewPage > 1
    },
    next: function () {
      return this.totolView > this.viewPage
    },
    current: function () {
      return this.data.current
    },
    total: function () {
      return this.data.total
    },
    length: function () {
      return this.data.length
    },
    totolView: function () {
      return Math.ceil(this.length / this.block)
    },
    pageNumber: function () {
      let pageNumber = this.block
      if (this.totolView === this.viewPage) {
        pageNumber = Math.ceil(this.length) - ((this.viewPage - 1) * this.block)
      }
      return new Array(pageNumber).fill(undefined).map((val, idx) => {
        return (idx + 1) + ((this.viewPage - 1) * this.block)
      })
    }
  },
  watch: {
    '$route.query' (query) {
      if (!query[this.pageQuery]) {
        return
      }
      this.viewPage = Math.ceil(Number(query[this.pageQuery]) / this.block)
    },
  },
  mounted () {
    if (this.$route.query[this.pageQuery]) {
      this.viewPage = Math.ceil(Number(this.$route.query[this.pageQuery]) / this.block)
    }
  },
  methods: {
    goPage (movePage) {
      this.$emit('movePage', movePage)
    },
    nextPage () {
      this.viewPage++
      this.$emit('movePage', this.pageNumber[0])
    },
    prevPage () {
      this.viewPage--
      this.$emit('movePage', this.pageNumber[this.pageNumber.length - 1])
    },
    more () {
      this.$emit('more')
    }
  }
}
</script>
